import posthog from "posthog-js";

const isEnabled = () => process.env.NODE_ENV !== "development";

/**
 * Identify the signed-in portal user. Prefer numeric Django user id as distinct_id.
 * Safe to call on every myaccount load / session restore — PostHog dedupes.
 */
export function identifyUser(user) {
  if (!isEnabled() || !user?.id) return;

  const properties = {};
  if (user.email) properties.email = user.email;
  if (user.username) properties.username = user.username;

  const name = [user.first_name, user.last_name].filter(Boolean).join(" ");
  if (name) properties.name = name;

  if (typeof user.is_staff === "boolean") properties.is_staff = user.is_staff;
  if (typeof user.is_superuser === "boolean") {
    properties.is_superuser = user.is_superuser;
  }

  posthog.identify(String(user.id), properties);
}

/**
 * Associate subsequent events with the focused campaign group.
 */
export function setCampaignGroup(campaign) {
  if (!isEnabled() || !campaign?.id) return;

  const properties = {};
  if (campaign.name) properties.name = campaign.name;
  if (typeof campaign.is_active === "boolean") {
    properties.is_active = campaign.is_active;
  }

  posthog.group("campaign", String(campaign.id), properties);
}

/** Clear identity on logout so the next visitor isn't linked to this person. */
export function resetUser() {
  if (!isEnabled()) return;
  posthog.reset();
}
